import State from './State.js';
export default class StateQuit extends State {
    constructor(context) {
        super(context);
        this.name = 'quit';
    }
    setup() {

    }
    action(command, value, player) {
        switch (command) {
            case "start": this.start(player); break;
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        actions.push({ command: "start", value: null });
        return actions;
    }

    start() {
        this.context.setState("preGame");
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand( command, null, player);
    }
    
}